import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import favicon from '@buzztime-live-trivia-2.0/utils/assets/favicon3.ico';

// Set favicon dynamically from shared assets
const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
link.rel = 'icon';
link.href = favicon;
document.head.appendChild(link);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
